import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { IconProps } from './types/IconProps';

export const CheckedIcon = (props: IconProps): ReactNode => (
  <Icon {...props} testId={locator.components.icon.checked}>
    <rect fill="currentColor" height="24" rx="3" width="24" x="0" y="0" />
    <path
      d="M4 12L10 18L20 6"
      fill="none"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </Icon>
);
